import React from 'react';
import { motion } from 'framer-motion';
import { scrollToOffer } from '../utils/scroll';
import { Star, Zap, Shield, Lock, Download, Flame } from 'lucide-react';
export function Hero() {
  return <section className="px-4 md:pt-14 md:pb-20 max-w-3xl mx-auto text-center pt-[40px] pb-[40px]" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-78">
        <p className="font-sans font-bold tracking-widest text-gold text-xs uppercase mb-4" data-id="element-79">
          eBookPlanet
        </p>

        {/* BESTSELLER BADGE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="inline-flex items-center gap-1.5 mb-5 rounded-full bg-gold px-4 py-1.5 text-white shadow-md" data-id="element-80">
          <Flame className="w-3.5 h-3.5 fill-current" data-id="element-81" />
          <span className="font-sans text-xs font-bold uppercase tracking-wider" data-id="element-82">
            Bestseller · #1 en amor propio
          </span>
        </motion.div>

        {/* PROMISE — big, bold, dark */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brown-900 font-bold leading-[1.05] mb-4" data-id="element-83">
          No es un libro más. Es el sistema que reprograma cómo pensás sobre vos
          mismo.
        </h1>

        <h2 className="font-serif text-xl md:text-2xl text-gold font-semibold italic leading-snug max-w-2xl mx-auto mb-6" data-id="element-84">
          Tu mente cree lo que le repetís. Este sistema decide lo que le
          repetís.
        </h2>

        {/* MOCKUP — directly below the title */}
        <motion.div className="flex justify-center mb-6" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/8VX35Lzw2GQ27ycqb16TnH/Mockup_v2-no_bg.png" alt="Hackeá tu Realidad — 3 tomos, 6 bonos y 390 páginas" className="w-[77%] max-w-[495px] h-auto drop-shadow-2xl text-[15.7px] font-[Inter,_sans-serif]" loading="eager" data-id="element-86" />
        </motion.div>

        {/* SUBTITLE — smaller, darker, legible */}
        <p className="font-sans md:text-lg text-brown font-medium max-w-xl mx-auto mb-6 text-[15.7px] leading-relaxed" data-id="element-87">
          Dejá de perder el tiempo con autoayuda vacía. Hackeá tu Realidad
          reprograma tu diálogo interno con un método paso a paso, desactiva el
          autosabotaje que te frena y pone a tu mente a trabajar. Con que leas
          unos minutos por día alcanza: el sistema hace el resto. Cambios que se
          aplican a todas las áreas de tu vida: salud, finanzas, relaciones,
          deporte, metas personales y más.
        </p>

        {/* BADGES — above the fold */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-sans text-brown mb-6 font-semibold" data-id="element-88">
          <span className="flex items-center gap-1" data-id="element-89">
            <Star className="w-4 h-4 text-gold fill-current" data-id="element-90" /> 4.9 / 5
          </span>
          <span className="text-brown/30" data-id="element-91">·</span>
          <span data-id="element-92">+500 lectores</span>
          <span className="text-brown/30" data-id="element-93">·</span>
          <span className="flex items-center gap-1" data-id="element-94">
            <Zap className="w-4 h-4 text-gold" data-id="element-95" /> Acceso inmediato
          </span>
        </div>

        {/* CTA — above the fold */}
        <button onClick={scrollToOffer} className="w-full md:w-auto px-10 py-4 bg-gold hover:bg-gold-600 text-white font-sans font-bold text-lg rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-96">
          QUIERO EMPEZAR HOY →
        </button>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-sans text-brown/60" data-id="element-97">
          <span className="flex items-center gap-1.5" data-id="element-98">
            <Lock className="w-3.5 h-3.5" data-id="element-99" /> Pago seguro
          </span>
          <span className="hidden sm:inline text-brown/30" data-id="element-100">·</span>
          <span className="flex items-center gap-1.5" data-id="element-101">
            <Download className="w-3.5 h-3.5" data-id="element-102" /> Descarga al instante
          </span>
          <span className="hidden sm:inline text-brown/30" data-id="element-103">·</span>
          <span className="flex items-center gap-1.5" data-id="element-104">
            <Shield className="w-3.5 h-3.5" data-id="element-105" /> Garantía
          </span>
        </div>
      </motion.div>
    </section>;
}